export default __webpack_public_path__ + "static/media/IMG_2028.c822b590.JPG";